/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black" :to="{ name: 'manageStoredSelect' , params: {brandPath: this.$route.params.brandPath}} "><p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s"> </p>
                    <p class="menu_center_tex_l">温度・湿度管理一覧</p>
                </div>
            </div>
         </div>
        <TemperatureList />
    </div>
</template>

<script>
    import TemperatureList from '@/app/components/TemperatureList.vue'
    export default {
        name: 'manageTemperatureList',
        components: {
            TemperatureList
        }
    }
</script>
